import I18n from 'i18n-js';
import React from 'react';
import { V3 } from '../api_request';
import Article from '../discovery/article';
import URLHelpers from '../shared/url_helpers';

interface Props {
  slug: string;
}

interface State {
  article: Article;
}

export default class ArticleEmbed extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      article: null,
    };
  }

  componentDidMount() {
    const req = V3.get(URLHelpers.articlesMultiplePath(), { slugs: [this.props.slug] });

    req.then((response) => {
      this.setState({ article: response.articles[0] });
    });
  }

  render() {
    const { article } = this.state;
    if (!article) { return null; }

    return (
      <aside className="article-embed" data-heading={I18n.t('discovery.articleEmbed.header')}>
        <a href={article._links.web.href}>
          <div className="article-embed__image">
            <img src={article.photo} alt={article.title} />
          </div>
          <div className="article-embed__details">
            <h1 className="article-embed__title">{article.title}</h1>
            <div className="article-embed__summary">
              {article.summary}
              <div className="article-embed__summary__readmore">
                {I18n.t('discovery.articleEmbed.readmore')}
              </div>
            </div>
          </div>
        </a>
      </aside>
    );
  }
}
